(function() {
    'use strict';
    angular.module('Const').constant('ComplianceConst', {
        frequencies: [
          'EVERY',
          'ONCE',
        ],
        units: [
            'MINUTES',
            'HOURS',
            'DAYS',
            'WEEKS',
            'MONTHS',
            'YEARS'
        ],
        events: [
            'NEW_DAY',
            'LOGIN',
            'LOGOUT'
        ]
    });
})();



// WEBPACK FOOTER //
// ./js/consts/complianceConst.js